import VueKline from './kline/kline'

export default VueKline;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-kline/src/index.js
// module id = 5NV6
// module chunks = 0